import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {Link} from "../../../../../stem-core/src/ui/UIPrimitives";

import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {Messages} from "../../../../Messages";
import {BasePanelPage} from "../../../PanelPage";
import {startDashboardFlow} from "../../../flows/startFlow";


export class NewsletterSubscribeSuccessPanel extends BasePanelPage {
    render() {
        const {styleSheet} = this;

        return [
            <div className={styleSheet.title}>{Messages.newsletterSubscribeSuccessTitle(iFrameMerchantService.getMerchant().getName())}</div>,
            <div className={styleSheet.message} style={{padding: "0 6px"}}>
                {Messages.newsletterSuccessMessage}<Link className={styleSheet.link} onClick={startDashboardFlow}>{Messages.myAccount}</Link>.
            </div>,
        ];
    }
}
